import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const UserMachineReviewSave = createAsyncThunk(
  "UserMachineReviewSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.USER_MACHINE_REVIEW.SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  UserMachineReviewSaveData: {
    data: null,
    error: null,
  },
};

const CartSlice = createSlice({
  name: "USERMACHINEREVIEW",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(UserMachineReviewSave.fulfilled, (state, action) => {
        state.UserMachineReviewSaveData.data = action.payload;
      })
      .addCase(UserMachineReviewSave.rejected, (state, action) => {
        state.UserMachineReviewSaveData.error = action.error.message;
      });
  },
});

export default CartSlice.reducer;
